import SumFooter from '../../../elements/Table/Footers/SumFooter'
import { moneyInline } from '../../../modules/Utils'
import React, { Component, Fragment } from 'react'
import { Popconfirm } from 'antd'
import NumberColumn from '../../../elements/Table/Columns/Number'
import { numVal, strVal } from '../../../modules/Utils'
import TableSpin from '../../../elements/TableSpin'
import CustomTable from '../../../elements/Table/CustomTable'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'

class InvoicesList extends Component {
  render() {
    const {
      fetchingInvoices,
      fetchingTransaction,
      fetchingReceipt,
      contract,
      invoices,
      handleChange,
      onChangeContract,
    } = this.props

    const { save, cancel, edit, remove } = this.props.invoicesOps
    const columns = [
      {
        Header: 'Code',
        accessor: 'code',
        Cell: ({ value, original }) => (
          <a target={'_blank'} href={`#/clients/invoices/${original._key}/view`} style={{ marginLeft: '10px' }}>
            {value}
          </a>
        ),
      },
      {
        Header: 'Type',
        accessor: 'invoiceType',
        Cell: ({ value }) => (value ? value.toUpperCase() : 'INVOICE'),
      },
      {
        Header: 'Sales Order',
        accessor: 'order.code',
      },
      {
        Header: 'CPO No',
        accessor: 'cpo.no',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Date',
        accessor: 'date',
      },
      {
        Header: 'Amount',
        accessor: 'subTotal.gross',
        Cell: ({ value, original }) => <span>{moneyInline(value, strVal(original, 'currency'))}</span>,
      },
      {
        Header: 'Paid',
        accessor: 'paid',
        Cell: ({ value, original }) => <span>{moneyInline(value, strVal(original, 'currency'))}</span>,
      },
      {
        Header: 'Conv. Amount',
        accessor: 'converted.gross',
        Footer: SumFooter,
        Cell: ({ value, original }) => <span>{moneyInline(value, strVal(original, 'converted.currency'))}</span>,
      },
      {
        Header: 'Conv. Paid',
        accessor: 'converted.paid',
        Footer: SumFooter,
        Cell: ({ value, original }) => {
          console.log(original)
          return <span>{moneyInline(value, strVal(original, 'converted.currency'))}</span>
        },
      },
      {
        Header: 'Conv. Rate',
        accessor: 'converted.rate',
        Footer: SumFooter,
        Cell: ({ value, original }) => (
          <NumberColumn
            precision={2}
            dataIndex={'_key'}
            onChange={handleChange}
            value={numVal({ value }, 'value')}
            record={original}
            column={'converted.rate'}
          />
        ),
      },

      {
        Header: 'Payment',
        accessor: 'amount',
        Cell: ({ value, original }) => (
          <NumberColumn
            precision={2}
            dataIndex={'_key'}
            onChange={handleChange}
            value={numVal({ value }, 'value')}
            record={original}
            column={'amount'}
          />
        ),
      },
      {
        Header: 'WH/ Tax',
        accessor: 'wtax.tax',
      },
      {
        Header: 'Discount',
        accessor: 'discount',
        Cell: ({ value, original }) => (
          <NumberColumn
            precision={2}
            dataIndex={'_key'}
            onChange={handleChange}
            value={value}
            record={original}
            column={'discount'}
          />
        ),
      },
      {
        Header: 'Bank Fees',
        accessor: 'bankFees',
        Cell: ({ value, original }) => (
          <NumberColumn
            precision={2}
            dataIndex={'_key'}
            onChange={handleChange}
            value={value}
            record={original}
            column={'bankFees'}
          />
        ),
      },
      {
        Header: 'Exchange Loss',
        accessor: 'exchangeLoss',
        Cell: ({ value, original }) => (
          <NumberColumn
            precision={2}
            dataIndex={'_key'}
            onChange={handleChange}
            value={value}
            record={original}
            column={'exchangeLoss'}
          />
        ),
      },
      {
        Header: 'New Balance',
        accessor: 'newBalance',
        Cell: MoneyCell,
      },
      {
        Header: 'Operation',
        accessor: 'operation',
        Cell: ({ value, original }) => {
          const { editable } = original
          return (
            <div className="editable-row-operations">
              {editable ? (
                <span>
                  <a onClick={() => save(original._key)}>Save</a>
                  <span className="ant-divider" />
                  <Popconfirm title="Sure to cancel?" onConfirm={() => cancel(original._key)}>
                    <a>Cancel</a>
                  </Popconfirm>
                </span>
              ) : (
                [
                  <a onClick={() => edit(original._key)}>Edit</a>,
                  <span className="ant-divider" />,
                  <a onClick={() => remove(original._key)}>Remove</a>,
                ]
              )}
            </div>
          )
        },
      },
    ]
    return (
      <Fragment>
        <CustomTable
          CreateButton={() => <span style={{ fontWeight: 'bold' }}>Invoices List</span>}
          fetch={() => onChangeContract(contract)}
          loading={fetchingInvoices || fetchingTransaction || fetchingReceipt}
          columns={columns}
          data={invoices}
          defaultPageSize={8}
          LoadingComponent={TableSpin}
        />
      </Fragment>
    )
  }
}

InvoicesList.defaultProps = {
  invoices: [],
}
export default InvoicesList
